import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import Button from '4all-ui/components/Button';
import Box from './Components/Box';
import BoxStatus from './Components/BoxStatus';
import BoxProduct from './Components/BoxProduct';
import Header from './Components/Header';
import { ORDER_TYPE, ORDER_SERVICES } from '../../../../helpers/constants';
import Loader from '../../../SharedComponents/Loader';
import Formats from '../../../../helpers/formats';
import * as styled from './style';

class OrderDetails extends Component {
  state = {
    order: {},
    user: {},
    header: {},
    scrollPosition: 0,
  };

  componentWillReceiveProps(nextProps) {
    if (Object.keys(nextProps.order).length > 1) {
      const { header } = this.state;

      this.setState({ orderUpdate: nextProps.order.id === header.idOrder });
      const { customer } = nextProps.order;
      this.setState({
        user: {
          title: 'Cliente',
          subtitle: (customer && customer.name) || '',
          data: [
            {
              field: 'E-mail',
              value: (customer && customer.emailAddress) || '',
            },
            {
              field: 'Telefone',
              value: (customer && customer.phoneNumber) || '',
            },
          ],
        },
        header: {
          idTransaction4all: nextProps.order.idTransaction4all,
          idOrder: nextProps.order.id,
          placeLabel: nextProps.order.placeLabel,
          status: nextProps.order.status,
          paymentStatus: nextProps.order.paymentStatus,
          paymentMethod: nextProps.order.paymentMethod || {},
          date: Formats.formatDate(nextProps.order.timestamp),
          scheduledTime: nextProps.order.scheduledTime,
          change: nextProps.order.change || 0,
          total: nextProps.order.total,
          brand: nextProps.order.brand || {},
          idOrderType: nextProps.order.idOrderType,
        },
      });

      let display = null;
      const orderType = ORDER_TYPE.find(type => type.id === nextProps.order.idOrderType);
      if (orderType) {
        ({ display } = orderType);

        if (display.first === 'Delivery') {
          display.last = nextProps.order.orderAddress
            ? nextProps.order.orderAddress.neighborhood
            : '';
        }
      }

      let order = {
        title: 'Destino',
        subtitle: nextProps.order.deliveryPersonallyObservation
          ? `Receber em Mãos`
          : this.parseOrderType(nextProps.order.idOrderType),
        packageInfo: this.createOrderPackageInfo(nextProps.order.idOrderType),
        display,
        idOrderType: nextProps.order.idOrderType,
      };

      if (nextProps.order.orderAddress && nextProps.order.idOrderType === ORDER_SERVICES.DELIVERY) {
        order = {
          ...order,
          data: [
            {
              field: 'Rua',
              value: `${nextProps.order.orderAddress.street}, ${
                nextProps.order.orderAddress.number
              }`,
            },
            {
              field: 'CEP',
              value: nextProps.order.orderAddress.cep,
            },
            {
              field: 'Referência',
              value: nextProps.order.orderAddress.complement,
            },
            {
              field: 'Bairro',
              value: nextProps.order.orderAddress.neighborhood,
            },
            {
              field: 'Cidade',
              value: nextProps.order.orderAddress.city,
            },
          ],
        };
      }

      if (nextProps.order.deliveryPersonallyObservation) {
        order = {
          ...order,
          data: [
            {
              field: 'Referência:',
              value: nextProps.order.deliveryPersonallyObservation,
            },
          ],
        };
      }

      this.setState({ order });
    }

    const { orderIsFetching } = this.props;

    if (nextProps.orderIsFetching !== orderIsFetching) {
      this.saveScrollPosition(nextProps.orderIsFetching);
    }
  }

  componentDidUpdate(prevProps) {
    const { orderIsFetching } = this.props;

    if (prevProps.orderIsFetching !== orderIsFetching) {
      this.setScrollPosition(orderIsFetching);
    }
  }

  setScrollPosition(orderIsFetching) {
    if (!orderIsFetching) {
      const { orderUpdate, scrollPosition } = this.state;

      document.querySelector('.order-container').scrollTop = orderUpdate ? scrollPosition : 0;
      this.setState({ scrollPosition: 0 });
    }
  }

  createOrderPackageInfo = orderTypeId => {
    switch (orderTypeId) {
      case ORDER_SERVICES.TAKEAWAY:
        return 'Produto embalado';
      case ORDER_SERVICES.DINEIN:
        return 'Produto pronto para consumo';
      default:
        return null;
    }
  };

  parseOrderType = id => {
    const orderType = ORDER_TYPE.find(item => item.id === id);

    return orderType ? orderType.label : '';
  };

  saveScrollPosition(orderIsFetching) {
    let scrollPosition = 0;

    if (orderIsFetching) {
      scrollPosition = document.querySelector('.order-container').scrollTop;
      this.setState({ scrollPosition });
    }
  }

  renderDetailsBoxContent = order => (
    <Fragment>
      <styled.ItemDescription>{order.subtitle}</styled.ItemDescription>
      <styled.OrderPackageInfo>{order.packageInfo}</styled.OrderPackageInfo>

      {order.data &&
        order.data.map(item => (
          <styled.Item key={`item-${item.field}`}>
            <styled.ItemTitle>{item.field}</styled.ItemTitle>
            <styled.ItemValue>{item.value}</styled.ItemValue>
          </styled.Item>
        ))}
    </Fragment>
  );

  renderHeaderContent = data => {
    if (!data) {
      return null;
    }

    const baseString = data.reduce((prev, curr) => {
      if (curr.field !== 'Referência') {
        return prev ? `${prev}, ${curr.value.trim()}` : curr.value.trim();
      }

      return prev;
    }, '');

    const formattedValue = baseString.replace(/\s/g, '+');
    const link = `https://www.google.com.br/maps/place/${formattedValue}`;

    return (
      <Button link onClick={() => window.open(link, '_blank')}>
        Abrir mapa
      </Button>
    );
  };

  render() {
    const { order: orderProp, orderIsFetching, merchant, putOrder } = this.props;
    const { header, user, order } = this.state;

    if (orderIsFetching) return <Loader />;

    if (!Object.keys(orderProp).length) return null;

    return (
      <styled.Container className="order-details-container">
        <Header
          orderDisplay={order.display}
          idOrderType={order.idOrderType}
          putOrder={putOrder}
          data={header}
          merchant={merchant}
          order={orderProp}
        />

        <styled.BoxContainer>
          <Box title={user.title} content={this.renderDetailsBoxContent(user)} />
          <Box
            title={order.title}
            content={this.renderDetailsBoxContent(order)}
            headerContent={this.renderHeaderContent(order.data)}
          />
        </styled.BoxContainer>

        <BoxProduct data={orderProp} />

        <BoxStatus data={orderProp.orderStatusLog} />
      </styled.Container>
    );
  }
}

OrderDetails.propTypes = {
  order: PropTypes.object,
  orderIsFetching: PropTypes.bool,
  putOrder: PropTypes.func.isRequired,
  merchant: PropTypes.object,
};

OrderDetails.defaultProps = {
  orderIsFetching: false,
  order: {},
  merchant: {},
};

export default OrderDetails;



// WEBPACK FOOTER //
// ./src/screens/Home/Components/OrderDetails/index.js